import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { AmplitudeService } from '@inyova/inyova-shared';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as AppRootActions from '@app/app.actions';

import { getCookie, getRedirectionDomainInfo } from '@shared/utils';

import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
class IdVerificationGuardService {
  constructor(
    private amplitudeService: AmplitudeService,
    private http: HttpClient,
    private router: Router,
    private store: Store
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const urlParams = route.queryParams;
    const transactionNumber = urlParams['transaction_number'] ?? '';
    const ubiIdCaseId = urlParams['ubiIdCaseId'] ?? '';
    const success = urlParams['success'] ?? '0';
    return new Observable<boolean | UrlTree>((observer) => {
      const number = transactionNumber || ubiIdCaseId;
      if (!number || !number.length) {
        observer.next(this.router.parseUrl('/login'));
      }

      return this.http
        .put(`${environment.apiUrlV3}/idnow_identifications/${number}`, {
          data: {
            id: '0',
            type: 'identifications',
            attributes: {
              status: success === '1' ? 'COMPLETED' : 'FAILED'
            }
          }
        })
        .subscribe(
          (value: { data: { attributes: { app_location: string; inyova_pro: boolean; provider_identifier: string; status: string } } }) => {
            if (value.data.attributes.inyova_pro) {
              const { finalDomain, appLocation } = getRedirectionDomainInfo(value.data.attributes.app_location, value.data.attributes.inyova_pro);

              const targetUrl = `https://${finalDomain}.inyova.${appLocation}`;
              window.location.href = targetUrl;
              return;
            }

            this.amplitudeService.trackEvent('ID Verification User Tasks Completed', {
              id_validation_provider_status_name: value.data.attributes.status
            });

            if (getCookie('accessToken')) {
              this.store.dispatch(AppRootActions.fetchCustomer());
            }
            observer.next(this.router.parseUrl('/'));
          },
          () => {
            observer.next(this.router.parseUrl('/'));
          }
        );
    });
  }
}

export const IdVerificationGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  return inject(IdVerificationGuardService).canActivate(route);
};
